import React from 'react';
import Seo from 'src/components/Seo';
import Container from 'src/components/shared/Container';
import seoConfig from '../seo.json';
import AlumniConnectSessions from 'src/components/AlumniConnect/AlumniConnectSessions';

const AlumniConnect = () => {
	const seoInfo = seoConfig['home-mentor'];
	return (
		<>
			<Seo title={seoInfo.title} description={seoInfo.description} />
			<Container>
				<AlumniConnectSessions />
			</Container>
		</>
	);
};

export default AlumniConnect;
